/*eslint-disable*/
// chakra imports
import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
  Avatar,
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import IconBox from "components/Icons/IconBox";
import { SpotifyLogo } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ProfileIcon } from "components/Icons/Icons";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { userSignOut } from "appRedux/actions/Auth";
import InfoPanel from "./InfoPanel";
import SidebarLink from "./SidebarLink";

// this function creates the links and collapses that appear in the sidebar (left menu)

// دسته‌هایی که چون به‌هم مرتبط هستن (فرآیند صدور صورتحساب)، باید توی یک باکس مجزا
// و پشت‌سر هم در سایدبار نمایش داده بشن. مقایسه با trim انجام می‌شه چون بعضی
// اسم‌ها در routes فاصله‌ی اضافه دارن (مثل " صورتحساب").
const RELATED_LINK_GROUP = ["طرف حساب/خریدار", "کالا/خدمات", "صورتحساب ها"];
const isInRelatedGroup = (prop) =>
  !prop.redirect &&
  !prop.separator &&
  RELATED_LINK_GROUP.includes((prop.name || "").trim());

const SidebarContent = ({ logoText, routes }) => {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});

  const dispatch = useDispatch();

  const activeColor = useColorModeValue("gray.700", "white");
  const groupBgColor = useColorModeValue("#39a499","brand.600")

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName) ? "active" : "";
  };

  const renderCategoryLabel = (prop) => (
    <Text
      color={activeColor}
      fontWeight="bold"
      mb={{
        xl: "12px",
      }}
      mx="auto"
      ps={{
        sm: "10px",
        xl: "16px",
      }}
      py="10px"
    >
      {prop.name}
    </Text>
  );

  const createLinks = (routes) => {
    const elements = [];
    let index = 0;

    while (index < routes.length) {
      const prop = routes[index];

      if (prop.redirect) {
        index += 1;
        continue;
      }

      if (prop.separator) {
        elements.push(
          <Separator my={2} key={`separator-${index}`} hasTitle={prop.separator} />,
        );
        index += 1;
        continue;
      }

      if (isInRelatedGroup(prop)) {
        // جمع کردن آیتم‌های مرتبطی که پشت‌سر هم اومدن، توی یک گروه
        const groupItems = [];
        while (index < routes.length && isInRelatedGroup(routes[index])) {
          groupItems.push(routes[index]);
          index += 1;
        }

        elements.push(
          <Box
            key={`related-group-${groupItems.map((item) => item.name).join("-")}`}
            boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
            py={5}
            gap={2}
            borderRadius="12px"
            borderLeftRadius={0}
            p="8px"
            pl={0}
            mb="16px"
            bg={groupBgColor}
          >
            {groupItems.map((groupProp) =>
              groupProp.category ? (
                <div key={groupProp.name}>
                  {renderCategoryLabel(groupProp)}
                  {createLinks(groupProp.views)}
                </div>
              ) : (
                <SidebarLink
                  key={groupProp.name}
                  prop={groupProp}
                  isActive={activeRoute(groupProp.path) === "active"}
                  onSignOut={() => dispatch(userSignOut())}
                />
              ),
            )}
          </Box>,
        );
        continue;
      }

      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        elements.push(
          <div key={prop.name}>
            {renderCategoryLabel(prop)}
            {createLinks(prop.views)}
          </div>,
        );
        index += 1;
        continue;
      }

      const isActive = activeRoute(prop.path) === "active";

      elements.push(
        <SidebarLink
          key={prop.name}
          prop={prop}
          isActive={isActive}
          onSignOut={() => dispatch(userSignOut())}
        />,
      );
      index += 1;
    }

    return elements;
  };

  const links = <>{createLinks(routes)}</>;

  /* return (
    <>
      <InfoPanel />
      <Stack direction="column" mb="40px">
        <Box>{links}</Box>
      </Stack>
    </>
  ); */
  return (
    <>
      <motion.div
        className="sidebar-scroll"
        style={{
          direction: "ltr",
          overflowY: "auto",
          height: "100vh",
          maxHeight: "100vh",
          /* paddingTop:"15px", */
          paddingBottom: "15px",
          paddingTop: "5px"
        }}
      >
        <div
          style={{
            direction: "rtl",
            paddingRight: "10px",
            paddingTop: "10px",
          }}
        >
          <Stack direction="column">
            <Box>{links}</Box>
          </Stack>
        </div>
      </motion.div>
    </>
  );
};

export default SidebarContent;